import React, { memo } from 'react';
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

function Crown({ ...other }) {
  return (
    <Box {...other}>
      <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Illustration">
          <g id="Ellipse 16">
            <circle cx="18" cy="18" r="18" fill="#E0E0FF" />
            <circle cx="18" cy="18" r="18" fill="white" fill-opacity="0.6" />
          </g>
          <path
            id="Vector"
            d="M26.4782 25.8266H9.78257C8.91961 25.8266 8.21735 26.5288 8.21735 27.3918C8.21735 28.2547 8.91961 28.957 9.78257 28.957H26.4782C27.3412 28.957 28.0434 28.2547 28.0434 27.3918C28.0434 26.5288 27.3412 25.8266 26.4782 25.8266ZM31.1739 12.2613C31.1739 13.3319 30.36 14.2064 29.3207 14.3253L27.3109 24.7831H8.94987L6.94011 14.3253C5.90081 14.2064 5.08691 13.3319 5.08691 12.2613C5.08691 11.1104 6.02294 10.1744 7.17387 10.1744C8.3248 10.1744 9.26083 11.1104 9.26083 12.2613C9.26083 13.0346 8.83299 13.7034 8.20588 14.0644C9.41215 16.9236 11.304 18.6777 13.057 18.519C15.0146 18.3594 16.6111 16.045 17.4918 12.1726C16.3628 11.8867 15.5217 10.8693 15.5217 9.65264C15.5217 8.21368 16.6915 7.04395 18.1304 7.04395C19.5694 7.04395 20.7391 8.21368 20.7391 9.65264C20.7391 10.8694 19.8981 11.8867 18.7691 12.1726C19.6498 16.045 21.2463 18.3594 23.2038 18.519C24.9642 18.6777 26.8477 16.9236 28.055 14.0644C27.4278 13.7034 27.0001 13.0345 27.0001 12.2613C27.0001 11.1104 27.9361 10.1744 29.087 10.1744C30.2378 10.1744 31.1739 11.1104 31.1739 12.2613Z"
            fill="url(#paint0_linear_538_63332)"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_538_63332"
            x1="18.1301"
            y1="7.68082"
            x2="18"
            y2="32.001"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#D55DB8" />
            <stop offset="1" stop-color="#3D49CC" />
          </linearGradient>
        </defs>
      </svg>
    </Box>
  );
}

export default memo(Crown);
